import React from 'react';

const Button = ({
  children,
  onClick,
  variant = 'primary', // primary, icon, disabled
  className = '',
  title,
  disabled = false,
  icon: Icon = null
}) => {
  const baseStyles = "rounded cursor-pointer";
  
  const variantStyles = {
    primary: "bg-white text-emerald-400 px-3 py-1 hover:bg-gray-100",
    icon: "bg-gray-200 rounded-full p-1 hover:bg-gray-100",
    disabled: "bg-gray-100 text-gray-400 cursor-not-allowed"
  };

  const finalClassName = `${baseStyles} ${variantStyles[disabled ? 'disabled' : variant]} ${className}`;

  return (
    <button
      className={finalClassName}
      onClick={!disabled ? onClick : undefined}
      title={title}
      disabled={disabled}
    >
      {Icon ? <Icon size={16} /> : children}
    </button>
  );
};

export default Button; 